module.exports = __webpack_public_path__ + "./assets/img/portfolio_3.09e93288.jpg";